import { Loader } from 'components/Loader'
import { IconSvg } from '@prism/icon'
import { setCustomClick } from 'utils/analyticsUtils'
import { getCurrentBidsUrl } from 'utils/urlUtils'
import { Link } from 'components/Share/Link'

interface Iprops {
  loading: boolean
  count: number
}

export const CurrentBidsCount = ({ loading, count }: Iprops) => {
  const manageBidsUrl = getCurrentBidsUrl()

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Link
          className="navigation-link"
          onClick={() => setCustomClick('Current Bids', { usePageName: true })}
          to={manageBidsUrl}
        >
          <span className="right-action">
            <IconSvg glyph="dollar-o" color="primary" />
            &nbsp;Current Bids&nbsp;<b>({count ?? 0})</b>
          </span>
        </Link>
      )}
    </>
  )
}
